module.exports = __webpack_public_path__ + "static/media/xlogo.0874d24f.svg";